const getDifferenceAsString = (forValue: number, againstValue: number): string => {
    const difference = forValue - againstValue
    return `${difference > 0 ? '+' : ''}${difference}`
}

export default getDifferenceAsString
